export const GET_EXAM_REPORT_CARD_WORD_TEMPLATES = 'GET_EXAM_REPORT_CARD_WORD_TEMPLATES'
export const CREATE_EXAM_REPORT_CARD_WORD_TEMPLATE = 'CREATE_EXAM_REPORT_CARD_WORD_TEMPLATE'
export const GET_EXAM_REPORT_CARD_WORD_TEMPLATE = 'GET_EXAM_REPORT_CARD_WORD_TEMPLATE'
export const UPDATE_EXAM_REPORT_CARD_WORD_TEMPLATE = 'UPDATE_EXAM_REPORT_CARD_WORD_TEMPLATE'
export const DELETE_EXAM_REPORT_CARD_WORD_TEMPLATE = 'DELETE_EXAM_REPORT_CARD_WORD_TEMPLATE'
export const GET_WORD_TEMPLATE_FORM_SETTINGS = 'GET_WORD_TEMPLATE_FORM_SETTINGS'
